import * as d3 from 'd3';
// Tools
import { no_propagate } from './utils';
// Custom hooks
import useAnimated from './useAnimated';
// Constants
import * as constants from './constants';

const MARGIN = 100;

const arcPathGenerator = d3.arc();

const NodeInvisible = ({ person, radius, segment_gap, selected_person_change, set_focused_this_person, set_unhighlighted_person, set_selected_this_person }) => {

  // Node
  const arc_params = {
    innerRadius: radius - constants.NODE_THICKNESS,
    outerRadius: radius + MARGIN,
    startAngle: person.start_angle - segment_gap/2,
    endAngle: person.end_angle + segment_gap/2,
  };
  const new_d_invisible = arcPathGenerator(arc_params);

  const [node_ref, {d}] = useAnimated({
    attrs : {'d' : {generator : arcPathGenerator, params : arc_params}},
    duration : selected_person_change ? 500 : 1000,
    deps : [new_d_invisible]
  });

  return (
    <path key={`invisible_${person.person_index}`}
          ref={node_ref}
          data-person_index={person.person_index}
          d={d}
          className={"node_invisible"}
          onMouseEnter={set_focused_this_person}
          onMouseLeave={set_unhighlighted_person}
          onClick={no_propagate(set_selected_this_person)}/>
  );
};

export default NodeInvisible;
